var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotfoundpost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 429.09 356.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.29,395.29c83.79,43.77,219.63,43.78,303.42,0s83.78-114.74,0-158.51-219.63-43.77-303.42,0S14.51,351.53,98.29,395.29Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.5,309.58s1.05-5.28,9.57-9.36c8.29-4,13.07-3.07,18.76-5.36s1.6-13.05-14-8.27c-14.29,4.38-15.74,16.75-15.74,16.75Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.5,309.58s1.05-5.28,9.57-9.36c8.29-4,13.07-3.07,18.76-5.36s1.6-13.05-14-8.27c-14.29,4.38-15.74,16.75-15.74,16.75Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,307.6a.51.51,0,0,1-.17,0,.55.55,0,0,1-.34-.7c2-5.72,7-11,13.52-14.22,8.36-4.09,14.31-2.79,14.56-2.73a.54.54,0,1,1-.24,1.06c-.06,0-5.85-1.26-13.84,2.65-6.25,3.06-11.1,8.14-13,13.6A.56.56,0,0,1,418,307.6Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.27,303s1-3,4.85-8.87c6.64-10.18,17.47-14.63,22.21-20.45,5.1-6.28-3.72-10.16-11.65-8-4.54,1.26-8.68,5.4-10.85,8.19a37.36,37.36,0,0,0-7.55,21Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.78,303.24h0a.55.55,0,0,1-.53-.56,46.17,46.17,0,0,1,5.51-18.85c6-10.77,14.9-14.6,15.28-14.76a.55.55,0,0,1,.42,1,34.18,34.18,0,0,0-14.75,14.28,44.93,44.93,0,0,0-5.37,18.35A.55.55,0,0,1,416.78,303.24Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,312c-7.19-4.83-7.51-17.83-6.47-26,1.65-13-5-16-8.39-10.26-1.64,2.79-3.7,8.85-3.47,15.91.37,11.06,5.16,24.29,16.76,29.09Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,312c-7.19-4.83-7.51-17.83-6.47-26,1.65-13-5-16-8.39-10.26-1.64,2.79-3.7,8.85-3.47,15.91.37,11.06,5.16,24.29,16.76,29.09Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.52,320a.49.49,0,0,1-.32-.12c-12.17-10.41-14.08-29-10.7-41.89a.5.5,0,1,1,1,.25c-3.3,12.59-1.47,30.75,10.38,40.88a.49.49,0,0,1,.05.7A.48.48,0,0,1,124.52,320Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.81,336c-6.26,4.5-20.65,8.39-25.33.68-4.35-7.17-1.44-10.3-10.27-9.06S90.35,322,92.44,316.2s-6.61-14.19-.26-20.73,10,7.06,13.68,8.53,5.93-1.7,10.17.61,4.65,11.76,8.78,11.94c6.76.31,18.14.26,19,6.29S136.81,336,136.81,336Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,333.36h-.05c-32.75-3.42-45.42-32-46.2-36.16a.5.5,0,1,1,1-.18c.76,4.09,13.17,32,45.32,35.35a.5.5,0,0,1,.45.55A.51.51,0,0,1,139.4,333.36Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.59,320.56a38.35,38.35,0,0,1-6.17-.5.5.5,0,0,1-.4-.58.49.49,0,0,1,.58-.4,34.71,34.71,0,0,0,11.28,0,.51.51,0,0,1,.6.39.5.5,0,0,1-.39.59A26.85,26.85,0,0,1,103.59,320.56Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.36,323.55h-.11a.5.5,0,0,1-.38-.59,40,40,0,0,0,.71-13.58.5.5,0,0,1,1-.16,40.31,40.31,0,0,1-.72,14A.5.5,0,0,1,113.36,323.55Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.07,284.42l15.7-9.06a5.42,5.42,0,0,1,4.87,0l2,1.15a5.37,5.37,0,0,1,2.44,4.22v18.12a5.39,5.39,0,0,1-2.44,4.22l-15.69,9.06a5.42,5.42,0,0,1-4.87,0l-2-1.15a5.37,5.37,0,0,1-2.43-4.22V288.64A5.4,5.4,0,0,1,52.07,284.42Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07,284.42l15.7-9.06a5.42,5.42,0,0,1,4.87,0l2,1.15a5.37,5.37,0,0,1,2.44,4.22v18.12a5.39,5.39,0,0,1-2.44,4.22l-15.69,9.06a5.42,5.42,0,0,1-4.87,0l-2-1.15a5.37,5.37,0,0,1-2.43-4.22V288.64A5.4,5.4,0,0,1,52.07,284.42Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.06,280.73c0-1.56-1.09-2.19-2.44-1.41l-15.69,9.06a5.39,5.39,0,0,0-2.44,4.22v18.12c0,1.55,1.09,2.18,2.44,1.41l15.69-9.06a5.39,5.39,0,0,0,2.44-4.22Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,306.76A5.37,5.37,0,0,0,52.07,311l2,1.15a5.43,5.43,0,0,0,4.45.19c-1.15.44-2-.21-2-1.6V292.6a4.87,4.87,0,0,1,.72-2.4l-6.86-4a5,5,0,0,0-.71,2.4Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,306.76A5.37,5.37,0,0,0,52.07,311l2,1.15a5.43,5.43,0,0,0,4.45.19c-1.15.44-2-.21-2-1.6V292.6a4.87,4.87,0,0,1,.72-2.4l-6.86-4a5,5,0,0,0-.71,2.4Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13,293.84l13.35-7.73c.35-.21.64,0,.64.37v9a1.45,1.45,0,0,1-.64,1.13L60.13,304.4c-.36.21-.65,0-.65-.38v-9A1.45,1.45,0,0,1,60.13,293.84Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.03 222.34 32 224.93 38.67 213.85 32.22 225.86 24.03 222.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07,238.69l15.7-9.06a5.36,5.36,0,0,1,4.87,0l2,1.15A5.36,5.36,0,0,1,77.06,235v18.12a5.35,5.35,0,0,1-2.44,4.21l-15.69,9.06a5.36,5.36,0,0,1-4.87,0l-2-1.14A5.4,5.4,0,0,1,49.64,261V242.91A5.4,5.4,0,0,1,52.07,238.69Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07,238.69l15.7-9.06a5.36,5.36,0,0,1,4.87,0l2,1.15A5.36,5.36,0,0,1,77.06,235v18.12a5.35,5.35,0,0,1-2.44,4.21l-15.69,9.06a5.36,5.36,0,0,1-4.87,0l-2-1.14A5.4,5.4,0,0,1,49.64,261V242.91A5.4,5.4,0,0,1,52.07,238.69Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.06,235c0-1.56-1.09-2.19-2.44-1.41l-15.69,9.06a5.37,5.37,0,0,0-2.44,4.22V265c0,1.55,1.09,2.18,2.44,1.4l15.69-9.06a5.35,5.35,0,0,0,2.44-4.21Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,261a5.4,5.4,0,0,0,2.43,4.22l2,1.14a5.39,5.39,0,0,0,4.45.2c-1.15.43-2-.21-2-1.6V246.87a4.87,4.87,0,0,1,.72-2.4l-6.86-4a5,5,0,0,0-.71,2.4Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,261a5.4,5.4,0,0,0,2.43,4.22l2,1.14a5.39,5.39,0,0,0,4.45.2c-1.15.43-2-.21-2-1.6V246.87a4.87,4.87,0,0,1,.72-2.4l-6.86-4a5,5,0,0,0-.71,2.4Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.62,257,65,256.82c-2.2-.18-4.82-1-4.82-4.19a7.38,7.38,0,0,1,3.34-5.78c1.44-.83,2.66-.49,3.13.71a7.47,7.47,0,0,1,3.13-4.33c1.85-1.06,3.34-.2,3.34,1.93,0,3.08-2.6,7-4.79,9.71Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07,193l15.7-9.06a5.36,5.36,0,0,1,4.87,0l2,1.15a5.35,5.35,0,0,1,2.44,4.21v18.12a5.36,5.36,0,0,1-2.44,4.22l-15.69,9.06a5.36,5.36,0,0,1-4.87,0l-2-1.14a5.4,5.4,0,0,1-2.43-4.22V197.19A5.4,5.4,0,0,1,52.07,193Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07,193l15.7-9.06a5.36,5.36,0,0,1,4.87,0l2,1.15a5.35,5.35,0,0,1,2.44,4.21v18.12a5.36,5.36,0,0,1-2.44,4.22l-15.69,9.06a5.36,5.36,0,0,1-4.87,0l-2-1.14a5.4,5.4,0,0,1-2.43-4.22V197.19A5.4,5.4,0,0,1,52.07,193Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.93,220.67c-1.35.78-2.44.15-2.44-1.4V201.15a5.36,5.36,0,0,1,2.44-4.22l15.69-9.06c1.35-.78,2.44-.15,2.44,1.4v18.12a5.36,5.36,0,0,1-2.44,4.22",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,215.31a5.4,5.4,0,0,0,2.43,4.22l2,1.14a5.39,5.39,0,0,0,4.45.2c-1.15.43-2-.21-2-1.6V201.15a4.87,4.87,0,0,1,.72-2.4l-6.86-4a5,5,0,0,0-.71,2.4Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.64,215.31a5.4,5.4,0,0,0,2.43,4.22l2,1.14a5.39,5.39,0,0,0,4.45.2c-1.15.43-2-.21-2-1.6V201.15a4.87,4.87,0,0,1,.72-2.4l-6.86-4a5,5,0,0,0-.71,2.4Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.91,204s1.83-4.22,2-4.83a18.12,18.12,0,0,0,0-3.14c0-.4,1.67-1.53,2.21-.37a6.09,6.09,0,0,1,.28,3.9l4.07-2.37c.86-.5,1.21.2,1.22.76a3,3,0,0,1-.66,1.75s.82-.24.82.85a2.87,2.87,0,0,1-1,2s.26.2.27,1a3.22,3.22,0,0,1-1.14,2,2.26,2.26,0,0,1,.18,1,3.11,3.11,0,0,1-1.49,2.34L64,212.8Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.6 144.38 27.53 142.67 27.49 132.47 24.55 134.18 24.6 144.38",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.48,139.46l24.06-13.89a8.24,8.24,0,0,1,7.46,0l3,1.75a8.24,8.24,0,0,1,3.74,6.47v27.78A8.23,8.23,0,0,1,78,168L54,181.92a8.26,8.26,0,0,1-7.47,0l-3-1.75a8.26,8.26,0,0,1-3.73-6.47V145.92A8.24,8.24,0,0,1,43.48,139.46Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.48,139.46l24.06-13.89a8.24,8.24,0,0,1,7.46,0l3,1.75a8.24,8.24,0,0,1,3.74,6.47v27.78A8.23,8.23,0,0,1,78,168L54,181.92a8.26,8.26,0,0,1-7.47,0l-3-1.75a8.26,8.26,0,0,1-3.73-6.47V145.92A8.24,8.24,0,0,1,43.48,139.46Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.78,133.62c0-1.39-.68-4.85-4.25-2.66S56.42,143.06,54,144.5a8.65,8.65,0,0,0-3.77,4.13l1.91,1.92Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.78,133.62c0-1.39-.68-4.85-4.25-2.66S56.42,143.06,54,144.5a8.65,8.65,0,0,0-3.77,4.13l1.91,1.92Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,181.92c-2.07,1.19-3.74.23-3.74-2.15V152A8.24,8.24,0,0,1,54,145.52L78,131.63c2.07-1.19,3.74-.22,3.74,2.16v27.78A8.23,8.23,0,0,1,78,168",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,181.92c-2.07,1.19-3.74.23-3.74-2.15V152A8.24,8.24,0,0,1,54,145.52L78,131.63c2.07-1.19,3.74-.22,3.74,2.16v27.78A8.23,8.23,0,0,1,78,168",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.75,173.7a8.26,8.26,0,0,0,3.73,6.47l3,1.75a8.33,8.33,0,0,0,6.83.3c-1.76.67-3.1-.32-3.1-2.45V152a7.6,7.6,0,0,1,1.1-3.68l-10.51-6.07a7.58,7.58,0,0,0-1.09,3.68Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.75,173.7a8.26,8.26,0,0,0,3.73,6.47l3,1.75a8.33,8.33,0,0,0,6.83.3c-1.76.67-3.1-.32-3.1-2.45V152a7.6,7.6,0,0,1,1.1-3.68l-10.51-6.07a7.58,7.58,0,0,0-1.09,3.68Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.74,142.28l3.12,5.5,7-2.86c.66-.27.93.51.45,1.33l-5.05,8.6,1.19,7.34c.11.7-.58,1.67-1.17,1.66L66,163.66l-6.25,7.4c-.59.7-1.28.52-1.17-.31L59.79,162l-5-2.77c-.48-.26-.21-1.35.45-1.84l7-5.2,3.12-9.11C65.59,142.25,66.44,141.76,66.74,142.28Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405,269.18c-12,5.71-31.4,5.71-43.38,0s-12-15,0-20.67,31.4-5.71,43.38,0S416.94,263.47,405,269.18Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.2,335.47a9.29,9.29,0,0,0,4.33,7.19l121.33,70a9.57,9.57,0,0,0,8.66,0l166-95.85a8.13,8.13,0,0,0,0-14.38L311.2,232.43a9.57,9.57,0,0,0-8.66,0l-166,95.85A9.29,9.29,0,0,0,132.2,335.47Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.26,301.88l-45.73,26.4a8.13,8.13,0,0,0,0,14.38l121.33,70a8.83,8.83,0,0,0,4.33,1V301.88Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.14,328.43a9.25,9.25,0,0,1-4.06-7.34V176.3a9.55,9.55,0,0,1,4.33-7.5L294.41,73a8.14,8.14,0,0,1,12.46,7.19V224.93a9.56,9.56,0,0,1-4.33,7.5l-166,95.85A9.27,9.27,0,0,1,128.14,328.43Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.39,183l-19-11a8.83,8.83,0,0,0-1.26,4.26V321.09a8.14,8.14,0,0,0,12.45,7.19l18.93-10.93Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.2,181V325.78c0,2.76,1.94,3.88,4.33,2.5l166-95.85a9.56,9.56,0,0,0,4.33-7.5V80.15c0-2.76-1.94-3.88-4.33-2.5l-166,95.84A9.59,9.59,0,0,0,132.2,181Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.53,333.28l121.33,70.05a9.57,9.57,0,0,0,8.66,0l166-95.85c2.4-1.38,2.4-3.62,0-5L311.2,232.43a9.57,9.57,0,0,0-8.66,0l-166,95.85C134.14,329.66,134.14,331.9,136.53,333.28Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.86,181.53,300.21,88.38c1.43-.83,2.6-.16,2.6,1.5V215.21a5.76,5.76,0,0,1-2.6,4.5L138.86,312.86c-1.44.83-2.6.16-2.6-1.5V186A5.73,5.73,0,0,1,138.86,181.53Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61,329.53l154.09-89a4.79,4.79,0,0,1,4.33,0l7.89,4.55a1.32,1.32,0,0,1,0,2.5L162.8,336.57a4.79,4.79,0,0,1-4.33,0L150.61,332A1.32,1.32,0,0,1,150.61,329.53Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.92,341.26l154.09-89a4.79,4.79,0,0,1,4.33,0l48.48,28a1.32,1.32,0,0,1,0,2.5L223.91,371.62a4.81,4.81,0,0,1-4.34,0l-48.64-27.88A1.31,1.31,0,0,1,170.92,341.26Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.05,292.32l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.11-.2.31,0,.44l5.58,3.22A.84.84,0,0,0,309.05,292.32Zm-9.52-11.07L294.71,284c-.21.12-.2.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.23A.87.87,0,0,0,299.53,281.25Zm-15.59,9L275.78,295c-.21.12-.19.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l8.16-4.71c.2-.12.19-.32,0-.44l-5.58-3.23A.87.87,0,0,0,283.94,290.25Zm8.54-4.93-4.83,2.79c-.2.11-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44l-5.58-3.22A.84.84,0,0,0,292.48,285.32Zm-18.93,10.93L268.73,299c-.21.12-.19.32,0,.45l5.58,3.22a.84.84,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.44l-5.58-3.23A.87.87,0,0,0,273.55,296.25Zm-7.05,4.07-4.82,2.78c-.21.12-.2.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.23A.87.87,0,0,0,266.5,300.32Zm21.95,13.1,4.82-2.79c.2-.12.19-.32,0-.44L287.66,307a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.11-.19.31,0,.44l5.58,3.22A.84.84,0,0,0,288.45,313.42Zm-7.06,4.07,4.83-2.79c.2-.12.19-.31,0-.44L280.61,311a.84.84,0,0,0-.77,0L275,313.81c-.21.11-.19.31,0,.44l5.58,3.22A.84.84,0,0,0,281.39,317.49Zm-7.05,4.07,4.83-2.79c.2-.11.19-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0L268,317.88c-.21.12-.2.32,0,.44l5.58,3.22A.84.84,0,0,0,274.34,321.56Zm-7,4.07,4.83-2.79c.2-.11.19-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0L260.92,322c-.21.12-.2.32,0,.44l5.58,3.22A.84.84,0,0,0,267.29,325.63ZM302,296.39l4.82-2.79c.21-.12.2-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.12-.2.31,0,.44l5.58,3.22A.84.84,0,0,0,302,296.39Zm-6.5,13,10.76-6.22c.2-.12.19-.32,0-.44l-13.55-7.82a.84.84,0,0,0-.77,0l-5.56,3.21c-.21.12-.2.32,0,.45l7.18,4.14c.22.13.23.33,0,.44l-4.45,2.58c-.2.11-.19.31,0,.44l5.58,3.22A.87.87,0,0,0,295.5,309.35Zm-36.05-5-4.82,2.79c-.21.11-.2.31,0,.44l5.58,3.22a.87.87,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22A.84.84,0,0,0,259.45,304.39Zm-7,4.07-4.83,2.79c-.2.12-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44l-5.58-3.22A.84.84,0,0,0,252.4,308.46Zm-35.24,45.65a.84.84,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.12-.2.31,0,.44ZM196,341l-4.83,2.79c-.2.11-.19.31,0,.44l5.58,3.22a.87.87,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44l-5.58-3.22A.84.84,0,0,0,196,341Zm11.35,9.55a.84.84,0,0,0,.77,0l4.82-2.79c.21-.12.19-.31,0-.44l-5.57-3.22a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.31,0,.44Zm22.27,6,4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.23a.87.87,0,0,0-.77,0l-4.82,2.79c-.21.11-.2.31,0,.44l5.58,3.22A.84.84,0,0,0,229.61,356.59Zm-7.82,4.05a.84.84,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0L216.19,357c-.21.11-.2.31,0,.44ZM203,337l-4.83,2.78c-.2.12-.19.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44L203.81,337A.87.87,0,0,0,203,337ZM238.3,316.6l-4.83,2.79c-.2.12-.19.32,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.11.19-.31,0-.44l-5.57-3.22A.87.87,0,0,0,238.3,316.6Zm-28.21,16.29-4.82,2.78c-.21.12-.2.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45l-5.58-3.22A.87.87,0,0,0,210.09,332.89Zm35.26-20.36-4.83,2.79c-.2.12-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.12.2-.31,0-.44l-5.58-3.22A.84.84,0,0,0,245.35,312.53Zm-14.11,8.14-4.82,2.79c-.21.12-.19.32,0,.44l5.58,3.23a.87.87,0,0,0,.77,0l4.82-2.78c.21-.12.19-.32,0-.45L232,320.69A.87.87,0,0,0,231.24,320.67Zm-7.05,4.08-4.82,2.78c-.21.12-.19.32,0,.44L225,331.2a.85.85,0,0,0,.76,0l4.83-2.78c.2-.12.19-.32,0-.45L225,324.76A.84.84,0,0,0,224.19,324.75Zm-7.05,4.07-4.82,2.78c-.21.12-.19.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45l-5.58-3.22A.87.87,0,0,0,217.14,328.82Zm36.05,4.95L258,331c.21-.12.2-.32,0-.45l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.78c-.2.12-.19.32,0,.45l5.58,3.22A.87.87,0,0,0,253.19,333.77Zm61.93-61.52L310.29,275c-.2.11-.19.31,0,.44l5.58,3.22a.87.87,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44l-5.58-3.22A.84.84,0,0,0,315.12,272.25Zm-8.54,4.93L301.76,280c-.21.12-.2.32,0,.45l5.57,3.22a.84.84,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.44l-5.58-3.23A.87.87,0,0,0,306.58,277.18Zm15.59-9L317.34,271c-.2.12-.19.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44l-5.58-3.23A.87.87,0,0,0,322.17,268.18Zm-36.5,37.64L290.5,303c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.78c-.2.12-.19.32,0,.45l5.58,3.22A.87.87,0,0,0,285.67,305.82ZM330,264.12a.87.87,0,0,0-.77,0l-4.82,2.78c-.21.12-.2.32,0,.45l5.58,3.22a.84.84,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45ZM260.24,329.7l4.82-2.78c.21-.12.2-.32,0-.45l-5.58-3.22a.87.87,0,0,0-.77,0L253.86,326c-.2.12-.19.32,0,.44l5.58,3.23A.87.87,0,0,0,260.24,329.7Zm86.47-49.92,4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.11-.19.31,0,.44l5.58,3.22A.84.84,0,0,0,346.71,279.78Zm-15-.53,4.82-2.79c.21-.12.2-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.11-.19.31,0,.44l5.58,3.22A.84.84,0,0,0,331.69,279.25ZM338,268.72a.87.87,0,0,0-.77,0l-4.82,2.79c-.21.11-.2.31,0,.44l5.58,3.22a.87.87,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44Zm1.48-.85L353,275.69a.87.87,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44L345,264.65a.87.87,0,0,0-.77,0l-4.82,2.78C339.21,267.54,339.22,267.74,339.44,267.87Zm-16.35,9-4.83,2.79c-.2.11-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44l-5.58-3.22A.84.84,0,0,0,323.09,276.85ZM270,307.49l-4.83,2.79c-.2.12-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.12.2-.31,0-.44l-5.58-3.22A.84.84,0,0,0,270,307.49Zm68.87-23.66a.84.84,0,0,0,.77,0l4.82-2.79c.21-.12.2-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.31,0,.44Zm-61.82,19.59-4.83,2.79c-.2.11-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44l-5.58-3.22A.84.84,0,0,0,277.07,303.42ZM224.21,350a.87.87,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.11-.2.31,0,.44Zm-10.6-10-4.83,2.79c-.2.11-.19.31,0,.44l5.58,3.22a.87.87,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44l-5.58-3.22A.84.84,0,0,0,213.61,340.06ZM232,346l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.78c-.21.12-.19.32,0,.45l5.58,3.22A.85.85,0,0,0,232,346Zm7.06-4.07,4.82-2.79c.21-.12.19-.32,0-.45l-5.58-3.22a.87.87,0,0,0-.77,0l-4.82,2.78c-.2.12-.19.32,0,.45l5.58,3.22A.87.87,0,0,0,239.09,341.92Zm7-4.08,4.82-2.78c.21-.12.19-.32,0-.45l-5.57-3.22a.87.87,0,0,0-.77,0l-4.83,2.78c-.2.12-.19.32,0,.45l5.58,3.22A.87.87,0,0,0,246.14,337.84ZM220.66,336l-4.83,2.78c-.2.12-.19.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44L221.43,336A.87.87,0,0,0,220.66,336Zm7.05-4.07-4.83,2.78c-.2.12-.19.32,0,.45l5.58,3.22a.84.84,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45l-5.58-3.22A.87.87,0,0,0,227.71,331.92Zm28.21-16.29-4.83,2.79c-.21.12-.19.32,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.11.19-.31,0-.44l-5.58-3.22A.85.85,0,0,0,255.92,315.63Zm-7.06,4.08L244,322.49c-.21.12-.19.32,0,.44l5.57,3.23a.87.87,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45l-5.58-3.22A.84.84,0,0,0,248.86,319.71ZM263,311.56l-4.83,2.79c-.2.12-.19.32,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.11.19-.31,0-.44l-5.57-3.22A.84.84,0,0,0,263,311.56Zm-28.21,16.29-4.82,2.78c-.21.12-.2.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45l-5.58-3.22A.87.87,0,0,0,234.76,327.85Zm7.05-4.07L237,326.56c-.21.12-.2.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45l-5.58-3.22A.84.84,0,0,0,241.81,323.78Zm-5.15,28.74,4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.23a.87.87,0,0,0-.77,0l-4.82,2.78c-.21.12-.19.32,0,.45l5.57,3.22A.87.87,0,0,0,236.66,352.52Zm-41.37-4.18-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.11-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79C195.52,348.66,195.5,348.46,195.29,348.34Zm10.56,3.1-5.58-3.22a.84.84,0,0,0-.77,0l-7.42,4.29c-.2.12-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l7.42-4.29C206.09,351.76,206.07,351.57,205.85,351.44Zm-19.12-9.33-5.58-3.22a.84.84,0,0,0-.77,0l-5.94,3.43c-.21.12-.19.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l5.93-3.43C187,342.44,187,342.24,186.73,342.11Zm4.55-2.63a.84.84,0,0,0,.77,0l4.82-2.79c.21-.12.2-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.31,0,.44ZM215.68,355l-5.58-3.22a.84.84,0,0,0-.77,0l-9.28,5.36c-.2.12-.19.32,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l9.28-5.36C215.91,355.29,215.9,355.1,215.68,355Zm4.63,6.53-5.58-3.22a.84.84,0,0,0-.77,0L208,361.69c-.2.12-.19.32,0,.44l5.58,3.23a.87.87,0,0,0,.77,0l5.94-3.43C220.54,361.82,220.53,361.63,220.31,361.5Zm23.4-52.29a.82.82,0,0,0,.76,0l4.83-2.79c.2-.11.19-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.12-.19.32,0,.44Zm-14.11,8.15a.87.87,0,0,0,.77,0l4.83-2.79c.2-.11.19-.31,0-.44l-5.58-3.22a.87.87,0,0,0-.77,0L224,313.69c-.21.12-.2.32,0,.44Zm-31.27,18.05a.87.87,0,0,0,.77,0l4.82-2.79c.21-.12.2-.32,0-.44L198.32,329a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.11-.19.31,0,.44Zm38.32-22.13a.84.84,0,0,0,.77,0l4.83-2.79c.2-.11.19-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.12-.19.32,0,.44Zm-14.1,8.15a.87.87,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45L222.54,315a.84.84,0,0,0-.77,0L217,317.76c-.21.12-.2.32,0,.45ZM224.18,362a.84.84,0,0,0-.77,0L216,366.29c-.2.12-.19.32,0,.45L221.6,370a.87.87,0,0,0,.77,0l7.42-4.28c.2-.12.19-.32,0-.45Zm-11.75-34.75a.84.84,0,0,0,.77,0L218,324.5c.2-.12.19-.32,0-.45l-5.58-3.22a.87.87,0,0,0-.77,0l-4.82,2.78c-.21.12-.2.32,0,.45Zm-7.05,4.07a.87.87,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.78c-.2.12-.19.32,0,.45ZM354.82,286.6a.87.87,0,0,0-.77,0l-11.88,6.86c-.2.12-.19.32,0,.44l5.58,3.23a.87.87,0,0,0,.77,0l11.87-6.86c.21-.11.2-.31,0-.44Zm-15.59,9a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.12-.2.32,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.83-2.79c.2-.11.19-.31,0-.44Zm-95.51,52.84,4.82-2.78c.2-.12.19-.32,0-.45L242.93,342a.87.87,0,0,0-.77,0l-4.82,2.78c-.21.12-.19.32,0,.45l5.58,3.22A.84.84,0,0,0,243.72,348.44Zm81.41-44.7a.84.84,0,0,0-.77,0l-4.83,2.78c-.2.12-.19.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l4.82-2.78c.21-.12.2-.32,0-.45Zm36.74-21.21a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l4.82-2.79c.21-.11.2-.31,0-.44Zm12.63-.85L361,273.86a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.11-.2.31,0,.44l13.55,7.82a.84.84,0,0,0,.77,0l4.83-2.79C374.73,282,374.72,281.81,374.5,281.68ZM298.78,319a.87.87,0,0,0-.77,0l-5.94,3.43c-.2.11-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l5.93-3.43c.21-.12.2-.32,0-.45Zm17.81-10.28a.87.87,0,0,0-.77,0l-7.42,4.29c-.2.12-.19.32,0,.44L314,316.6a.84.84,0,0,0,.77,0l7.42-4.29c.2-.11.19-.31,0-.44Zm-34.14,19.71a.84.84,0,0,0-.77,0L242,351.29c-.21.12-.19.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l39.7-22.92c.21-.12.2-.32,0-.45Zm-41.94,24.21a.87.87,0,0,0-.77,0L233.8,356c-.2.12-.19.31,0,.44l5.58,3.22a.84.84,0,0,0,.77,0l5.94-3.43c.2-.12.19-.32,0-.44Zm50.1-28.92a.84.84,0,0,0-.77,0l-5.93,3.43c-.21.12-.2.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0l5.94-3.43c.2-.12.19-.31,0-.44Zm-58.26,33.64a.84.84,0,0,0-.77,0l-5.94,3.43c-.21.12-.19.32,0,.45l5.58,3.22a.87.87,0,0,0,.77,0L238,361c.21-.12.2-.31,0-.44Zm74.59-43.07a.87.87,0,0,0-.77,0l-5.94,3.43c-.2.12-.19.32,0,.45l5.58,3.22a.84.84,0,0,0,.77,0l5.94-3.42c.2-.12.19-.32,0-.45Zm25.24-14.57a.87.87,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.44l5.58,3.23a.87.87,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45Zm15.45-11.22,4.82-2.79c.21-.12.2-.31,0-.44L346.85,282a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.44l5.58,3.22A.84.84,0,0,0,347.63,288.45Zm-31.53-.2,4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.11-.2.31,0,.44l5.58,3.22A.87.87,0,0,0,316.1,288.25Zm-16,27.63,14.1-8.15c.2-.11.19-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-14.1,8.14c-.21.12-.19.32,0,.45l5.58,3.22A.87.87,0,0,0,300.13,315.88Zm39.68-23.38a.84.84,0,0,0,.77,0l4.82-2.78c.21-.12.19-.32,0-.45l-5.58-3.22a.87.87,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.44Zm-7.2-4.58,4.82-2.79c.21-.11.2-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.44l5.58,3.22A.84.84,0,0,0,332.61,287.92Zm-39.54,32,4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.11-.19.31,0,.44l5.57,3.22A.87.87,0,0,0,293.07,320Zm31.15-18.45a.84.84,0,0,0,.77,0l4.83-2.79c.2-.11.19-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.12-.2.32,0,.44Zm-66.4,38.8,4.82-2.78c.21-.12.19-.32,0-.45L257,333.85a.87.87,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.45l5.58,3.22A.87.87,0,0,0,257.82,340.3Zm7.05-4.07,4.82-2.78c.21-.12.2-.32,0-.45l-5.58-3.22a.87.87,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.44l5.58,3.22A.84.84,0,0,0,264.87,336.23Zm-14.1,8.14,4.82-2.78c.21-.12.19-.32,0-.45L250,337.92a.84.84,0,0,0-.77,0l-4.83,2.78c-.2.12-.19.32,0,.45l5.58,3.22A.87.87,0,0,0,250.77,344.37ZM279,328.09l4.83-2.79c.2-.12.19-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.12-.2.31,0,.44l5.58,3.22A.84.84,0,0,0,279,328.09Zm-7.05,4.07,4.83-2.79c.2-.11.19-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.44l5.58,3.22A.84.84,0,0,0,271.92,332.16ZM286,324l4.83-2.79c.2-.12.19-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.12-.19.31,0,.44l5.58,3.22A.84.84,0,0,0,286,324Zm32.26-60.23a.84.84,0,0,0,.77,0l4.83-2.79c.2-.12.19-.31,0-.44l-1.49-.86a.84.84,0,0,0-.77,0l-4.82,2.78c-.2.12-.19.32,0,.45Zm-34.69,22.4a.87.87,0,0,0,.77,0l4.82-2.78c.21-.12.2-.32,0-.45l-5.58-3.22a.84.84,0,0,0-.77,0L278,282.52c-.2.12-.19.32,0,.45Zm14.1-8.15a.84.84,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45l-5.58-3.22a.87.87,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.44ZM275,291.16a.84.84,0,0,0,.77,0l4.82-2.78c.21-.12.2-.32,0-.45L275,284.72a.87.87,0,0,0-.77,0l-4.83,2.78c-.2.12-.19.32,0,.45Zm15.66-9a.87.87,0,0,0,.77,0l4.82-2.78c.21-.12.2-.32,0-.45l-5.58-3.22a.84.84,0,0,0-.77,0L285,278.45c-.2.12-.19.32,0,.44ZM260.88,299.3a.87.87,0,0,0,.77,0l4.82-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.78c-.21.12-.19.32,0,.45Zm7.05-4.07a.84.84,0,0,0,.77,0l4.82-2.78c.21-.12.19-.32,0-.45l-5.57-3.22a.87.87,0,0,0-.77,0l-4.83,2.78c-.2.12-.19.32,0,.45Zm36.25-23.3a.84.84,0,0,0,.77,0l4.82-2.78c.21-.12.2-.32,0-.45l-1.49-.86a.87.87,0,0,0-.77,0l-4.82,2.78c-.21.12-.2.32,0,.45Zm21.15-12.21a.84.84,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44l-1.48-.86a.87.87,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.32,0,.44Zm11.72,6.77a.87.87,0,0,0,.77,0l4.83-2.78c.2-.12.19-.32,0-.45L337,260.05a.87.87,0,0,0-.77,0l-4.82,2.78c-.21.12-.2.32,0,.45Zm17.63,17.89,4.82-2.79c.21-.12.2-.31,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.83,2.79c-.2.12-.19.31,0,.44l5.58,3.22A.84.84,0,0,0,354.68,284.38Zm-43.45-16.52a.84.84,0,0,0,.77,0l4.83-2.79c.2-.11.19-.31,0-.44l-1.49-.86a.87.87,0,0,0-.77,0l-4.82,2.78c-.21.12-.19.32,0,.45Zm-57.41,35.51a.87.87,0,0,0,.77,0l4.83-2.79c.2-.12.19-.32,0-.44l-5.58-3.22a.84.84,0,0,0-.77,0l-4.82,2.79c-.21.11-.19.31,0,.44Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.04 275.32 299.85 244.83 332.35 263.59 279.54 294.08 247.04 275.32",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.42,166.39,333.77,75.54c3.08-1.78,5.6-.32,5.6,3.23V200.65a5.79,5.79,0,0,1-2.6,4.5L175.42,298.3c-1.43.82-2.6.15-2.6-1.5V172.62A8,8,0,0,1,176.42,166.39Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.37,81.69V78.77c0-3.55-2.52-5-5.6-3.23L176.42,166.39a8,8,0,0,0-3.6,6.23v5.23Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.9,88.34A4.29,4.29,0,0,0,314,91.68c0,1.23.87,1.73,1.93,1.11a4.22,4.22,0,0,0,1.93-3.33C317.83,88.23,317,87.73,315.9,88.34Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.55,83.93a4.24,4.24,0,0,0-1.93,3.34c0,1.23.86,1.72,1.93,1.11A4.27,4.27,0,0,0,325.48,85C325.48,83.81,324.61,83.31,323.55,83.93Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.2,79.51a4.26,4.26,0,0,0-1.93,3.34c0,1.23.86,1.73,1.93,1.11a4.24,4.24,0,0,0,1.92-3.33C333.12,79.4,332.26,78.9,331.2,79.51Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.37 105.97 137.37 129.42 303.91 33.27 303.91 9.81 137.37 105.97",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.37 105.97 137.37 129.42 303.91 33.27 303.91 9.81 137.37 105.97",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.73,189.08a3.51,3.51,0,0,1-1.73.09V177.68a1.36,1.36,0,0,1,.14-.63,1.31,1.31,0,0,1,.48-.45l.86-.49c.22-.13.38-.17.48-.11s.15.21.15.46v3.78a6.66,6.66,0,0,1,1.14-1.34,8.51,8.51,0,0,1,1.52-1.1c1.26-.73,2.23-.9,2.92-.49s1,1.34,1,2.78a9.09,9.09,0,0,1-1.2,4.61,9.43,9.43,0,0,1-3.55,3.45A8.69,8.69,0,0,1,183.73,189.08Zm4.18-4.69a6.23,6.23,0,0,0,.67-3c0-1-.18-1.6-.53-1.85s-.94-.15-1.77.33a5,5,0,0,0-1.51,1.37,3,3,0,0,0-.66,1.82V187a1.69,1.69,0,0,0,.78-.1,5.51,5.51,0,0,0,1-.44A5.18,5.18,0,0,0,187.91,184.39Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.5,183.91c-.1-.07-.15-.21-.15-.45V171.7a1.25,1.25,0,0,1,.15-.63,1.17,1.17,0,0,1,.48-.45l.89-.51c.22-.13.38-.16.48-.11s.15.21.15.46v11.76a1.17,1.17,0,0,1-.14.61,1.22,1.22,0,0,1-.49.46l-.89.51C192.75,183.93,192.59,184,192.5,183.91Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.33,180.25c-.79-.43-1.18-1.4-1.18-2.93a8.34,8.34,0,0,1,1.18-4.3,9.06,9.06,0,0,1,3.37-3.27c1.45-.84,2.58-1,3.37-.62s1.19,1.4,1.19,2.93a8.25,8.25,0,0,1-1.19,4.3,9.08,9.08,0,0,1-3.37,3.28C199.24,180.48,198.12,180.68,197.33,180.25Zm5.18-4.28a5.58,5.58,0,0,0,.62-2.68c0-1-.21-1.65-.62-1.94s-1-.2-1.81.26a4.68,4.68,0,0,0-1.81,1.83,5.45,5.45,0,0,0-.63,2.66q0,1.52.63,2c.42.3,1,.22,1.81-.23A4.66,4.66,0,0,0,202.51,176Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.29,177.47a3.41,3.41,0,0,1-1.41.25c-.18,0-.22-.13-.13-.35l.48-1.23a.7.7,0,0,1,.2-.31.33.33,0,0,1,.17,0A5,5,0,0,0,211,175a4.4,4.4,0,0,0,1.65-1.57,4.82,4.82,0,0,0,.52-2.4,6.75,6.75,0,0,1-1.1,1.5,7,7,0,0,1-1.52,1.16c-1.25.72-2.23.89-2.93.51s-1.05-1.3-1.05-2.73a8.37,8.37,0,0,1,1.25-4.47,10,10,0,0,1,3.62-3.4,8.19,8.19,0,0,1,2.14-.89,3.83,3.83,0,0,1,1.7-.11v6.65a9.16,9.16,0,0,1-1,4.26,7.76,7.76,0,0,1-3.1,3.13A11.84,11.84,0,0,1,209.29,177.47Zm3.29-7.4a3.47,3.47,0,0,0,.59-1.92V164.7a2.62,2.62,0,0,0-.81.2,6.69,6.69,0,0,0-1,.49,5,5,0,0,0-2.65,4.65c0,1,.19,1.56.58,1.81s1,.13,1.78-.32A4.46,4.46,0,0,0,212.58,170.07Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25,195.26v82.43c0,.55.29.83.64.62a1.79,1.79,0,0,0,.64-1.39V194.49c0-.55-.29-.82-.64-.61A1.75,1.75,0,0,0,201.25,195.26Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.51,227.24l36.29-21c1.2-.69,2.17-.13,2.17,1.25v25.53a4.78,4.78,0,0,1-2.17,3.75l-36.29,20.95c-1.19.69-2.16.13-2.16-1.25V231A4.8,4.8,0,0,1,152.51,227.24Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,207.53c0-1.38-1-1.94-2.17-1.25l-36.29,21a4.8,4.8,0,0,0-2.16,3.75v2.17L191,209.71Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.95 163.63 135.2 154.25 135.2 170.67 118.95 180.05 118.95 163.63",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41,249.54l6.09-10.82a.68.68,0,0,1,1.17-.13l2.13,2.34,3.67-8.47c.22-.51.65-.56,1-.1l2.22,3.15v7l-16.25,9.38Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,225.2c0,.78.58,1.08,1.3.66l9.58-5.53a2.81,2.81,0,0,0,1.3-2.17c0-.78-.58-1.08-1.29-.66L176,223A2.78,2.78,0,0,0,174.72,225.2Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,232c0,.78.58,1.08,1.3.67l9.58-5.54a2.79,2.79,0,0,0,1.3-2.17c0-.78-.58-1.07-1.29-.66L176,229.78A2.81,2.81,0,0,0,174.72,232Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,238.7c0,.79.58,1.08,1.3.67l9.58-5.54a2.77,2.77,0,0,0,1.3-2.16c0-.78-.58-1.08-1.29-.67L176,236.54A2.77,2.77,0,0,0,174.72,238.7Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.51,266.76l36.29-20.95c1.2-.69,2.17-.13,2.17,1.25v25.53a4.78,4.78,0,0,1-2.17,3.75l-36.29,21c-1.19.69-2.16.13-2.16-1.25V270.51A4.8,4.8,0,0,1,152.51,266.76Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,247.06c0-1.38-1-1.94-2.17-1.25l-36.29,20.95a4.8,4.8,0,0,0-2.16,3.75v2.18L191,249.23Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.95 203.15 135.2 193.77 135.2 210.19 118.95 219.57 118.95 203.15",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41,289.07l6.09-10.82a.68.68,0,0,1,1.17-.13l2.13,2.33,3.67-8.47c.22-.51.65-.55,1-.1l2.22,3.15v7l-16.25,9.38Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,264.72c0,.78.58,1.08,1.3.67l9.58-5.54a2.77,2.77,0,0,0,1.3-2.16c0-.79-.58-1.08-1.29-.67L176,262.56A2.77,2.77,0,0,0,174.72,264.72Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,271.47c0,.79.58,1.08,1.3.67l9.58-5.54a2.77,2.77,0,0,0,1.3-2.16c0-.78-.58-1.08-1.29-.67L176,269.31A2.77,2.77,0,0,0,174.72,271.47Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,278.23c0,.78.58,1.08,1.3.66l9.58-5.53a2.81,2.81,0,0,0,1.3-2.17c0-.78-.58-1.08-1.29-.66L176,276.06A2.81,2.81,0,0,0,174.72,278.23Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.61,228.19l111.57-64.41c1.19-.69,2.16-.13,2.16,1.25v32.53a4.8,4.8,0,0,1-2.16,3.75L215.61,265.72c-1.2.69-2.17.13-2.17-1.25V231.94A4.78,4.78,0,0,1,215.61,228.19Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.34,165c0-1.38-1-1.94-2.16-1.25L215.61,228.19a4.78,4.78,0,0,0-2.17,3.75v2.17l115.9-66.91Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,221.43l-22.54,13a3.86,3.86,0,0,0-1.73,3v22.28c0,1.1.78,1.55,1.73,1l22.54-13a3.85,3.85,0,0,0,1.73-3V222.43C242.69,221.33,241.91,220.88,241,221.43Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.64,241,216.69,258v1.76c0,1.1.78,1.55,1.73,1l22.54-13a3.85,3.85,0,0,0,1.73-3V237l-4.26-8c-.52-1-1.29-.95-1.72.07L230,244.82l-3.26-4.06A1.14,1.14,0,0,0,224.64,241Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.3,240.8a8.6,8.6,0,0,0,3.89-6.74,3.25,3.25,0,0,0-.59-2l-4.18,2.41a3.86,3.86,0,0,0-1.73,3v3.71A2.84,2.84,0,0,0,219.3,240.8Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.87,216.53l69.66-40.21c1-.56,1.73-.18,1.73.84a3.69,3.69,0,0,1-1.73,2.84l-69.66,40.22c-1,.55-1.73.17-1.73-.85A3.69,3.69,0,0,1,252.87,216.53Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.87,225.91l69.66-40.21c1-.56,1.73-.18,1.73.84a3.69,3.69,0,0,1-1.73,2.84L252.87,229.6c-1,.55-1.73.17-1.73-.85A3.7,3.7,0,0,1,252.87,225.91Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.87,235.29l69.66-40.21c1-.56,1.73-.18,1.73.84a3.72,3.72,0,0,1-1.73,2.85L252.87,239c-1,.55-1.73.17-1.73-.85A3.7,3.7,0,0,1,252.87,235.29Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.84,125.31,356.62,125c-.69-.58-11.43-12.7-11.43-12.7s-3.86,6.09-3.93,6.48,10.53,11.72,11.58,12.86a3.15,3.15,0,0,0,2.5,1.23c2.77.16,13.14.89,13.14.89Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.92 65.18 330.16 64.01 331.38 53.43 347.65 53.79 345.92 65.18",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.92 65.18 330.16 64.01 331.38 53.43 347.65 53.79 345.92 65.18",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.92,171.86l111.57-64.41c1.19-.69,2.16-.13,2.16,1.25v32.54a4.81,4.81,0,0,1-2.16,3.75L235.92,209.4c-1.2.69-2.17.13-2.17-1.25V175.61A4.78,4.78,0,0,1,235.92,171.86Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.65,108.7c0-1.38-1-1.94-2.16-1.25L235.92,171.86a4.78,4.78,0,0,0-2.17,3.75v2.17l115.9-66.91Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.27,165.11l-22.54,13a3.83,3.83,0,0,0-1.73,3v22.27c0,1.1.78,1.55,1.73,1l22.54-13a3.83,3.83,0,0,0,1.73-3V166.11C263,165,262.22,164.56,261.27,165.11Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,184.68,237,201.63v1.76c0,1.1.78,1.55,1.73,1l22.54-13a3.83,3.83,0,0,0,1.73-3v-7.69l-4.26-8c-.52-1-1.29-.94-1.72.07l-6.71,15.78-3.26-4.07A1.15,1.15,0,0,0,245,184.68Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.61,184.48a8.63,8.63,0,0,0,3.89-6.75,3.27,3.27,0,0,0-.59-2l-4.18,2.42a3.83,3.83,0,0,0-1.73,3v3.7A2.84,2.84,0,0,0,239.61,184.48Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,160.2,342.84,120c1-.55,1.73-.18,1.73.84a3.71,3.71,0,0,1-1.73,2.85l-69.66,40.21c-.95.55-1.73.18-1.73-.84A3.72,3.72,0,0,1,273.18,160.2Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,169.58l69.66-40.21c1-.55,1.73-.17,1.73.84a3.71,3.71,0,0,1-1.73,2.85l-69.66,40.21c-.95.56-1.73.18-1.73-.84A3.72,3.72,0,0,1,273.18,169.58Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,179l69.66-40.21c1-.55,1.73-.17,1.73.84a3.71,3.71,0,0,1-1.73,2.85l-69.66,40.21c-.95.56-1.73.18-1.73-.84A3.72,3.72,0,0,1,273.18,179Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.14,
    y: 177.04,
    width: 5.9,
    height: 8.6,
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.98,
    y: 238.37,
    width: 5.9,
    height: 8.6,
    transform: "translate(-43.56 -58.76) rotate(-1.97)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.11,165c0,5.64.73,42.11.73,42.11.14,1.62,1.66,4.61,1.33,10.85-.44,8.46-1.18,32-1.18,32s-2.76,2.75-6.67,0c0,0-5.35-31.95-6.41-40.33-.92-7.32-2.49-27.21-2.49-27.21L381,205.78s1,5.5,1.18,9.39-1,26.31-1,26.31a6.44,6.44,0,0,1-6.42.25S370,209,369.35,205.44,373.5,165,373.5,165Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.23,125.93l.08,0a11.7,11.7,0,0,1,8.8,11.39V165c-4.14,4.5-18.57,6.6-27.61,0V136.2c0-4.6,2.55-10.13,9.61-10.54Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.21,102.39a3.15,3.15,0,0,1,2.61.92c1.12,1.14.88,3.26,0,8.12l-3.46.4Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.07,101a5.46,5.46,0,0,1-2.17-.44c-1.06-.61-1.33.59-.75,1.64a4.92,4.92,0,0,0,4,2.67c0-.15,1-2.7,1-2.7Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.59,111.83c.52.31,1.25-.68,1.88-1.34a2.23,2.23,0,0,1,3.73.61c1.05,2.21-1.33,5.15-2.73,6.12a2.46,2.46,0,0,1-2.88.25l-.36,8.46a9,9,0,0,1-6.81,5.16c-5,.68-3.94-3.42-2.31-5.43v-3.07a11.93,11.93,0,0,1-3.78.19c-.65-.17-2.19-2-3.19-4.13-1.12-2.35-3-6.52-1.33-13.57,1.79-7.57,9.92-7.8,14.77-4.75S392.59,111.83,392.59,111.83Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.59,112.7c.26,0,1.24-1.63,1.88-2.21.89-.8-.26-8.1-.26-8.1s.9-2.76-.85-4.6-5.14-1.52-7.62-1.61a22.27,22.27,0,0,1-8.86-1.78c-3.51-1.53-3.78-1.71-4.21-.16s-.61,5.08,1.5,7.46l1.74.64s.95.84,4.23,1.24a47.87,47.87,0,0,0,9.09-.18c.95-.13,1.16.8,1.67,3.32C391.35,108.93,391.73,112.68,392.59,112.7Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.21,103l3.1-1.66a1.71,1.71,0,0,0-2.35-.78A1.85,1.85,0,0,0,394.21,103Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.12,122.59a35.73,35.73,0,0,0,6.21-1.78,5.4,5.4,0,0,0,2.22-2.2,7.24,7.24,0,0,1-1.26,2.59c-1.18,1.5-7.17,2.61-7.17,2.61Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.22,110.68a.93.93,0,1,0,.92-1A.95.95,0,0,0,384.22,110.68Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.2,107.2l2,1.09a1.18,1.18,0,0,0-.46-1.57A1.09,1.09,0,0,0,385.2,107.2Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.29,116.93l-2.1.79a1.1,1.1,0,0,0,1.43.7A1.18,1.18,0,0,0,384.29,116.93Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,108l1.8-1.39a1.09,1.09,0,0,0-1.56-.24A1.2,1.2,0,0,0,376,108Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.56,110.42a.92.92,0,0,0,.92,1,1,1,0,1,0-.92-1Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.8 37.67 345.5 43.21 342.6 42.23 345.8 37.67",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.6,254.6v-.84c-.57.24-1.88,5.25-4.22,7.39-1.87,1.7-4.41,3.66-5.05,5.55s3.54,3.06,5.28,2.75c2-.36,5.52-1.78,6.4-3.1s1.29-3.27,2-4.23,2.36-2.05,2.75-3.17a7.16,7.16,0,0,0-.34-3.1c-.27-1-.57-2.19-.93-2.09v.64a4.62,4.62,0,0,1-2.95,1C397.69,255.43,395.59,255.26,395.6,254.6Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.07,245.25c-.31,0-.56.44-1.24,1.18a12.85,12.85,0,0,1-3.47,2.5c-2.21,1.1-6.51,2.8-8.45,3.68-1.22.55-1.16,2,.09,2.85s4.29,1.44,7.94.62c2-.44,4.56-2.27,6.2-2.17s4.69.07,5.9-.76.72-2.61.38-4.13c-.37-1.67-.91-4.22-1.46-4.1l0,.52c-.71,1.07-4.32,1.51-5.88.72Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,129.77l-18.24,18.86s-16-2.86-21.46-4.43c-1.72-.49-2.92-3.06-3.3-5a3.85,3.85,0,0,0-1.37-2.59s0,1.41-.36,3.72c-.14,1-1.72,1.13-3.13,1.44-5,1.08-6.7,0-8.77,1.44-1.6,1.14.41,4.1,4.06,5.1,5.13,1.41,8,.71,11.08,1.48,2.41.6,19.75,6,23.05,6.76,1.74.38,3.07.26,5-1.61s16.29-14.43,16.29-14.43Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.81,129.12c-2-.51-14.2,14-14.2,14l6.72,5.64s8.7-5.7,10.24-8S400.86,130.63,394.81,129.12Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.77,149.14s9.18-8.22,9.61-9.12c.83-1.73.6-4.93.6-4.93s1,2.78,0,4.93-8,8.26-9.11,9.31l-1.13,1.06-1.09-1,.65-.57Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.77,149.14s9.18-8.22,9.61-9.12c.83-1.73.6-4.93.6-4.93s1,2.78,0,4.93-8,8.26-9.11,9.31l-1.13,1.06-1.09-1,.65-.57Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.65,108.44c2-.22,3.33-1.7,3.78-1.29a1.11,1.11,0,0,1,.06,1.45,13.72,13.72,0,0,1-3,1.73,22.85,22.85,0,0,0-.54,3.09c-.17,1.53-.11,4.59-1.42,5.63-3.91,3.14-4.91-1.84-4.76-5.18C336,109.72,339.56,108.67,341.65,108.44Z",
    transform: "translate(-35.45 -71.88)",
    style: {
      fill: "#f28f8f"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfoundpost);
export default __webpack_public_path__ + "static/media/notfoundpost.8ce87f275ea8b70e9e4245eb0715f428.svg";
export { ForwardRef as ReactComponent };